<template>
  <a-select
    v-model="_value"
    @search="search"
    showSearch
    allowClear
    :filter-option="false"
    @popupScroll="test"
    ref="mySelect"
  >
    <a-icon slot="suffixIcon" type="search" />
    <a-select-option
      v-for="(item, index) in roomsArr"
      :key="index"
      :value="item.objectId"
      >{{ item.community.name }}-{{ item.building.name }}-{{
        item.unit.name
      }}-{{ item.room.name }}</a-select-option
    >
    <a-select-option v-if="showLoading" disabled :key="roomsArr.length + 1">
      <div class="spin" style="width:100%">
        <a-spin style="margin:auto" />
      </div>
    </a-select-option>
  </a-select>
</template>
<script>
// import Bus from '../../assets/js/eventBus'
export default {
  syncProps: ['value'],
  props: {
    value: null,
    field: Object
  },
  data () {
    return {
      roomsArr: [],
      count: 0,
      data: {
        room: ''
      },
      showLoading: false, // 是否显示加载
      more: true, // 是否还有更多
      searchValue: ''
    }
  },
  mounted () {
    // Bus.$on('reset', this.reset)
    this.getRoomsArr()
  },
  methods: {
    search (a) {
      this.more = true
      this.showLoading = false
      this.count = 0
      this.roomsArr = []
      this.searchValue = a
      this.getRoomsArr()
    },
    async getRoomsArr () {
      let where = {}
      if (this.searchValue) {
        where = {
          room: {
            $inQuery: {
              className: 'roomNumber',
              where: {
                name: {
                  $regex: this.searchValue
                }
              }
            }
          }
        }
      }
      let { data: res } = await this.$tkParse.get('/classes/house', {
        params: {
          include: 'room,unit,building,community',
          limit: 10,
          skip: 10 * this.count,
          where: where
        }
      })
      if (res.results.length < 10) {
        this.more = false
      } else {
        this.more = true
      }
      this.roomsArr = [...this.roomsArr, ...res.results]
      this.showLoading = false
      this.$forceUpdate()
    },
    test (e) {
      const { target } = e
      const { scrollHeight, clientHeight, scrollTop } = target
      if (scrollHeight - clientHeight - scrollTop === 0 && this.more) {
        this.loadMore()
      }
      // let mySelect = this.$refs.mySelect
      // console.log(mySelect)
    },
    async loadMore () {
      if (!this.showLoading) {
        this.showLoading = true
        this.count++
        await this.getRoomsArr()
        this.showLoading = false
      }
    },
    filterQuery () {
      // if (this.data.room) {
      //   this._value = this.data.room
      // } else {
      //   this._value = ''
      // }
      // if (this._value) {
      return this._value
      // }
    },
    setValue () {
      this._value = null // 不会报错
    },
    reset (payload) {
      this.data.room = payload
    }
  }
}
</script>

<style>
.spin {
  margin: auto;
  cursor: not-allowed;
  text-align: center;
  /* pointer-events: none; */
}
</style>
